export enum RelocationOrderFlowRouteType {
  BranchToBranch = "branch-to-branch",
  BranchToExternalAddress = "branch-to-external-address",
  ExternalAddressToBranch = "external-address-to-branch",
}

export enum RelocationOrderFlowTransportMethodSegment {
  TransportCompany = "transport-company",
  OwnAxle = "own-axle",
}
